import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWheel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-wheel",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 12h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 12h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.6 9.4l3.4 -4.8" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.4 14.6l-3.4 4.8" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 4.6l3.4 4.8" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.6 14.6l3.4 4.8" })
	]
});
const ForwardRef = forwardRef(SvgWheel);
export default ForwardRef;
